import MyBHArticleCard from "@components/Blocks/Card/MyBHArticle/MyBHArticleCard";
// import MyBHAlertBlock from "@components/Blocks/FirebaseNotificationPrompt/MyBHAlertBlock";
import FollowTopicsPageVariant from "@components/Blocks/FollowTrendingTopics/FollowTopicsPageVariant";
import FollowTrendingTopics, {
  TopicsData,
} from "@components/Blocks/FollowTrendingTopics/FollowTrendingTopics";
import { AdsImu2 } from "@elements/Advertisement/variant/AdsImu";
import Heading from "@elements/Typography/Heading";
import ViewFeedCTA from "@elements/ViewFeedCTA/ViewFeedCTA";
import mapArticleToMyBHArticleCardProps from "@helper/mapArticleToCardProps";
import { isArrayWithElements } from "@helper/utils";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
import { LightboxHandle } from "@hooks/useMySPHLightbox";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { PageAdTargetValue } from "@typings/Ads";
import { twMerge } from "tailwind-merge";

export type RenderFollowingProps = {
  activeTab: "untukmu" | "pilihanku";
  trendingTopics: TopicsData[];
  followedArticles: ProcessedArticleData[];
  adsSectionName: string;
  pageAdTarget: PageAdTargetValue;
  isLoggedIn: boolean;
  toggleTopic: (topicId: string, topicTitle: string) => Promise<void>;
  shuffleTopics: () => Promise<void>;
  followedIds: string[];
  selectedIds: string[];
  lightbox: LightboxHandle | null;
  loadingTopicId: string | null;
  bhCustomEvent?: ReturnType<typeof useBHCustomEventAnalyticsCall>;
  userKeywords?: string;
};

export default function RenderFollowing({
  activeTab,
  trendingTopics,
  followedArticles,
  adsSectionName,
  pageAdTarget,
  isLoggedIn,
  toggleTopic,
  shuffleTopics,
  followedIds,
  selectedIds,
  lightbox,
  loadingTopicId,
  bhCustomEvent,
  userKeywords,
}: RenderFollowingProps) {
  const isVisible = activeTab === "pilihanku";

  return (
    <div
      data-testid="pilihanku-container"
      className={twMerge(isVisible ? "block" : "hidden")}
    >
      {!isArrayWithElements(followedArticles) ? (
        <WidgetWrapper className="flex justify-center flex-col items-center gap-6 pb-8">
          <FollowTopicsPageVariant
            topicsData={trendingTopics}
            onFollow={toggleTopic}
            onUnfollow={toggleTopic}
            onShuffle={shuffleTopics}
            selected={selectedIds}
            unSelect={toggleTopic}
            loadingTopicId={loadingTopicId}
          />
          <ViewFeedCTA
            isLoggedIn={isLoggedIn}
            followedIds={followedIds}
            selectedIds={selectedIds}
            lightbox={lightbox}
            bhCustomEvent={bhCustomEvent}
            userKeywords={userKeywords}
          />
        </WidgetWrapper>
      ) : (
        <WidgetWrapper>
          <div className="flex flex-col lg:flex-row gap-[39px]">
            <div className="flex flex-col gap-4">
              <Heading Element="h2">Today:</Heading>
              <div className="flex flex-col gap-8">
                {followedArticles.map((article) => {
                  const cardProps = mapArticleToMyBHArticleCardProps(article);
                  return (
                    <MyBHArticleCard
                      key={`followed-tags-article-${article.id}}`}
                      {...cardProps}
                    />
                  );
                })}
              </div>
            </div>
            <div className="w-full lg:max-w-[300px] flex flex-col items-center gap-5">
              <div>
                <AdsImu2
                  uniqueSectionName={adsSectionName}
                  pageAdTargetType={pageAdTarget}
                />
              </div>
              <FollowTrendingTopics
                key="following-tags"
                topicsData={trendingTopics}
                onFollow={toggleTopic}
                onUnfollow={toggleTopic}
                onShuffle={shuffleTopics}
                selected={selectedIds}
                unSelect={toggleTopic}
                loadingTopicId={loadingTopicId}
                isLoggedIn={isLoggedIn}
                followedIds={followedIds}
                selectedIds={selectedIds}
                lightbox={lightbox}
                variant="widget"
                bhCustomEvent={bhCustomEvent}
              />
              {/* Disable alert block for now.
              <MyBHAlertBlock
                key="following-tags-alert"
                onToggle={function (enabled: boolean): void {
                  console.log("Clicked to alert enabled", enabled);
                  throw new Error("Function not implemented.");
                }}
                uniqueKey="following-tags-page"
              /> */}
            </div>
          </div>
        </WidgetWrapper>
      )}
    </div>
  );
}
